export var reduxKey = '@@TAG_INPUT';
//# sourceMappingURL=constants.js.map